import { ILocalization, ILocalizationToken } from '../../../../../../../application/language/ILocalization';
import { extensionContainer } from '../../../../../../../common/container/ContainerContext';
import { IPerformerTypeSearch } from '../../../../../../../service/performer/type/IPerformerTypeSearch';
import { injectRootService } from '../../../../../../../service/RootServiceFactory';
import { UserSystemRoleModelPermissionMap } from '../../../../../../../service/systemRole/entity/actions/UserSystemRoleModelPermissionMap';
import TableHeader from '../../../../../../design/dataTable/parts/appBar/TableHeader';
import { DataTableDomain } from '../../../../../../design/dataTable/store/DataTableDomain';
import { DefaultTableSlots } from '../../../../../../design/dataTable/store/DataTableUI';
import { IMainLayoutDomainStore } from '../../../../../../layout/main/store/domain/IMainLayoutDomainStore';
import { UserModalDomain } from './modal/UserModalDomain';
import { UserAdminModel } from './UserAdminModel';
import { UserAdminUI } from './UserAdminUI';

export class CustomAppBar {
  Toolbar = TableHeader;
}
export class UserAdminDomain extends DataTableDomain<UserAdminModel, IPerformerTypeSearch> {
  public ui: UserAdminUI;
  constructor(
    layoutDomain: IMainLayoutDomainStore,
    public rootPrivateServices = injectRootService(layoutDomain.serviceType.value),
  ) {
    super(layoutDomain, rootPrivateServices.user.entity);
    this.ui = new UserAdminUI(this, null);
    this.modalDomain = new UserModalDomain(rootPrivateServices.user.entity, layoutDomain, this);
    const i18n: ILocalization = extensionContainer.getByToken(ILocalizationToken)
    this.ui.tableSlots.setEntity(new CustomAppBar() as DefaultTableSlots);
    this.ui.tableTitle?.setValue(i18n.translate('settingsUser.pageTitle'));
    this.ui.tableSubtitle?.setValue(i18n.translate('phrases.users'));
  }
  async loadData() {
    await this.loadDependencies();

    await super.loadList();
    this.setPermissions();
  }

  async loadDependencies() {
    const [usersAndRoles, projectsSearchResult] = await Promise.all([
      this.rootPrivateServices.user.entity.getUserLoginsAndRoles(),
      this.rootPrivateServices.project.entity.search({ limit: 1000000 }),
    ]);
    const rolesIdsAndNames = usersAndRoles.map((item) => ({ id: item.systemRoleId, name: item.userRole }));
    const uniqueRoles = rolesIdsAndNames.filter((role, index, self) =>
      index === self.findIndex((roleInSelf) => roleInSelf.id === role.id)
    );
    this.ui.systemRoleId.setList(uniqueRoles);
    this.ui.projects.setList(projectsSearchResult.data);
  }

  async loadApplicationsById(applicationId) {
    const specificationsIds = (await this.rootPrivateServices.application.entity.getById(applicationId));

    return specificationsIds
  }

  async setPermissions() {
    super.setPermissions();
    this.ui.isCanCreate.setValue(
      this.layoutDomain.userHaveAnyAccess([UserSystemRoleModelPermissionMap['settings-user-entity-create']]),
    );
    this.ui.isCanDelete.setValue(
      this.layoutDomain.userHaveAnyAccess([UserSystemRoleModelPermissionMap['settings-user-entity-delete']]),
    );
    this.ui.isCanEdit.setValue(
      this.layoutDomain.userHaveAnyAccess([UserSystemRoleModelPermissionMap['settings-user-entity-update']]),
    );
  }

  async setNoDeletePermission() {
    this.ui.isCanDelete.setValue(false);
  }
}
